import { Gauge } from "lucide-react"

import { Slider } from "@/components/ui/slider"

interface EffortSliderProps {
  /** Levels the selected model accepts, weakest first. Fewer than two → no control. */
  levels: string[]
  value: string | null
  onChange: (effort: string) => void
}

export function EffortSlider({ levels, value, onChange }: EffortSliderProps) {
  if (levels.length < 2) return null

  // useModels guarantees `value` is one of `levels`; guard only against a race
  // between a model switch and the next render.
  const position = Math.max(0, value ? levels.indexOf(value) : 0)

  return (
    <div className="flex max-w-fit items-center gap-2.5 self-start rounded-full border border-border bg-card py-1.5 pr-3 pl-3">
      <Gauge className="size-3.5 shrink-0 text-fg3" />
      <span className="shrink-0 text-xs text-fg3">Effort</span>
      <Slider
        value={[position]}
        min={0}
        max={levels.length - 1}
        step={1}
        onValueChange={([next]) => onChange(levels[next])}
        aria-label="Reasoning effort"
        className="w-24"
      />
      <span className="w-12 shrink-0 text-xs font-medium text-fg1">{levels[position]}</span>
    </div>
  )
}
